// src/config/gauges/optichiller1Comp.js (ejemplo de nombre)
// Ajusta el nombre del export si tu máquina/componente se llama diferente. Presiones = Licuaador 1comp

export const optichiller1CompGaugeConfig = [
  // Columna 1 — Presión Succión C1
  {
    key: "presionSuccionComp1",
    title: "Pres. Succión Compresor 1",
    unit: "psi",
    ranges: [
      { min: 21, max: 29.99, color: "green" },
      { min: 18, max: 20.99, color: "yellow" },
      { min: 30, max: 34.99, color: "yellow" },
      { min: 0,  max: 17.99, color: "red" },
      { min: 35, max: 1000, color: "red" },
    ],
  },

  // Columna 2 — Temp Proceso Entrada
  {
    key: "tempProcesoEntrada",
    title: "Temp. Proceso Entrada",
    unit: "°C",
    ranges: [
      { min: -17,  max: -13.99, color: "green" },
      { min: -13.99,  max:-9.99,  color: "yellow" },
      { min: -19, max: -16.99, color: "yellow" },
      { min: -9.99,  max: 0,  color: "red" },
      { min: -20.1, max: -18.99, color: "red" },
    ],
  },

  // Columna 3 — Temp Torre Entrada bien 
  {
    key: "tempTorreEntrada",
    title: "Temp. Torre Entrada",
    unit: "°C",
    ranges: [
      { min: 28, max: 30.99, color: "green" },
      { min: 25, max: 27.99, color: "yellow" },
      { min: 31, max: 34.99, color: "yellow" },
      { min: 0,  max: 24.99, color: "red" },
      { min: 35, max: 50000, color: "red" },
    ],
  },

  // Columna 4 — Temp Descarga C1 bien 
  {
    key: "tempDescargaComp1",
    title: "Temp. Descarga Compresor 1",
    unit: "°C",
    ranges: [
      { min: 45, max: 69.99,  color: "green" },
      { min: 40, max: 44.99,  color: "yellow" },
      { min: 70, max: 90.99,  color: "yellow" },
      { min: 0,  max: 39.99,  color: "red" },
      { min: 91, max: 15000, color: "red" },
    ],
  },

  // Columna 5 — Presión Descarga C1 licuador 
  {
    key: "presionDescargaComp1",
    title: "Pres. Descarga Compresor 1",
    unit: "psi",
    ranges: [
       { min: 156, max: 195.99, color: "green" },
      { min: 140, max: 155.99, color: "yellow" },
      { min: 196, max: 209.99, color: "yellow" },
      { min: 0,   max: 139.99, color: "red" },
      { min: 210, max: 350000, color: "red" },
    ],
  },

  // ---------- Fila 2 ----------

  // Columna 2 — Temp Proceso Salida
  {
    key: "tempProcesoSalida",
    title: "Temp. Proceso Salida",
    unit: "°C",
    ranges: [
      { min: -20,  max: -18.99, color: "green" },
      { min: -18.99,  max: -15.99,  color: "yellow" },
      { min: -21, max: -19.99, color: "yellow" },
      { min: -15.99,  max: 0,  color: "red" },
      { min: -21.1, max: -1000.99, color: "red" },
    ],
  },

  // Columna 3 — Temp Torre Salida bien 
  {
    key: "tempTorreSalida",
    title: "Temp. Torre Salida",
    unit: "°C",
    ranges: [
      { min: 32, max: 34.99, color: "green" },
      { min: 26, max: 31.99, color: "yellow" },
      { min: 35, max: 37.99, color: "yellow" },
      { min: 0,  max: 25.99, color: "red" },
      { min: 38, max: 50000, color: "red" },
    ],
  },
]